import React from 'react';
import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE_MB } from '../../utils/constants';
import DocumentTypeDescription from './DocumentTypeDescription';

const SupportingDocumentDescription = () => {
  const typeList = new Intl.ListFormat('en', { type: 'disjunction' }).format(
    ALLOWED_FILE_TYPES,
  );
  return (
    <>
      <p>
        If you don’t have one of the documents listed here, the Veteran will
        need to sign the application for themselves.
      </p>

      {DocumentTypeDescription}

      <p>
        <strong>What to know about uploading files</strong>
      </p>
      <ul className="vads-u-margin-bottom--3">
        <li>Use a {typeList} file</li>
        <li>
          Make sure the file is {MAX_FILE_SIZE_MB}
          <dfn>
            <abbr title="Megabytes">MB</abbr>
          </dfn>{' '}
          or less.
        </li>
        <li>
          If you only have a paper copy, scan or take a photo and upload the
          image.
        </li>
        <li>
          Be sure to upload the entire document. We can’t accept a cover or
          signature page without the rest of the document.
        </li>
      </ul>
    </>
  );
};

export default SupportingDocumentDescription;
